
import { DatePipe } from "@angular/common";
import { Component, OnInit, OnDestroy, HostListener, ViewChild, TemplateRef } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { Location } from '@angular/common';
import { ApiService } from "./services/api.service";
import { Subscription, timer } from "rxjs";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],

})
export class AppComponent implements OnInit, OnDestroy {

  day: string;
  month: string;
  date: string;
  time: string;
  gmtValue = 'Europe/Rome';
  timer;
  texts = Array(10).fill('gates');
  ispotrait:boolean;
  ref: MatDialogRef<any>;
  rotated:boolean = false
  datatype;
  langvalue;
  langlist = [{name: 'English',code:'En'},{name:'Italic', code:'It'}]
  @ViewChild("privacycomponent", { read: TemplateRef, static: false }) privacycomponent: TemplateRef<any>;
  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.checkorientation();
    if(this.ispotrait){
      this.rotated = true;
    }
  }

  @HostListener ('window:focus', ['$event'])
  onFocus (event: any): void {
    this.ispotrait = window.innerHeight > window.innerWidth ? true : false 
    window.location.reload();
  }


  @ViewChild("DialogComponent", { read: TemplateRef, static: false }) DialogComponent: TemplateRef<any>;
  showlang:boolean=false;
  langconfig;
  langcode;
  isOnline: boolean = true;
  touchedtime:boolean;
  refreshedcalling:boolean = false;
  private connectivitySubscription: Subscription;
  constructor(private datepipe: DatePipe, public dialog: MatDialog, private location: Location, private apiservice : ApiService) {
    this.connectivitySubscription = this.apiservice.isOnline.subscribe(status => {
      this.apiservice.isoffline.next(status)
      this.isOnline = status;
    });
    timer(0, 1000).subscribe(() => {
      const dateInGMT = new Date(new Date().toLocaleString('en-US', { timeZone: this.gmtValue }));
      this.time = this.datepipe.transform(dateInGMT, 'HH:mm:ss');
      if(this.time == '00:00:00'){ // if the time is 00:00:00 then it will refresh the page
        this.refreshedcalling = true; // setting the refreshedcalling to true after 00:00:00
        this.apiservice.setbacktohome(false); // setting the backtohome to false
        this.refreshpage(); // calling the refreshpage function
      }
    });
    const langcode = sessionStorage.getItem('lang');
    this.langvalue = langcode ? langcode : this.langlist[0].code;
    const langjson = this.langvalue == 'En' ? this.langlist[0] : this.langlist[1];
    this.apiservice.language.next(langjson);
   }
  
  ngOnInit(): void {
    this.refreshpage();
    this.checkorientation();
    const langcode = sessionStorage.getItem('lang');
    if(!langcode){
      sessionStorage.setItem('lang', this.langlist[0].code);
      this.apiservice.language.next(this.langlist[0]);
      this.langvalue = this.langlist[0].code
    }
    this.apiservice.language.subscribe((res)=>{
      this.langcode = res.code
      this.langconfig = this.langcode == 'En' ? require("./Language/En-us.json") : require("./Language/It-us.json")
    })
  }

  checkverifyapifail(){
    this.apiservice.verifyapifailed.subscribe((res)=>{
      if(res == true){
        this.opendialog()
      }
    })
  }

  refreshpage(){
    let timertime;
    this.apiservice.showvideo.subscribe((res)=>{ // subscribes the value when device is interacted if interacted or live video is streaming it will return false
      if(res == false){
        this.touchedtime = true; // if the showvideo is false setting the touchedtime to true
      }else if(res == true){
        this.touchedtime = false; // if the showvideo is true setting the touchedtime to false
      }
      const backtohome = this.apiservice.getbacktohome(); // getting the value of backtohome from the api service
      if(this.touchedtime == true && this.refreshedcalling == true && backtohome == false){ // if the touchedtime is true and refreshedcalling is true then it will reload the page after 95 seconds
        timertime ? timertime.unsubscribe() : null; // clearing the subscriber before initializing the new subscriber
        timertime = timer(95000).subscribe(() => { // setting the timer for 95 seconds
          this.touchedtime = false; // setting the touchedtime to false after 95 seconds
          window.location.reload(); // reloading the page after 95 seconds
        });
      }else  if(this.touchedtime == true && backtohome == true && this.refreshedcalling == true){
        this.apiservice.setbacktohome(false); // setting the backtohome to false
        timertime ? timertime.unsubscribe() : null; // clearing the subscriber before initializing the new subscriber
        timertime = timer(5000).subscribe(() => { // setting the timer for 5 seconds
          window.location.reload(); // if the backtohome is true then it will reload the page
        });
      } else if(this.touchedtime == false && this.refreshedcalling == true && backtohome == false){ // if the touchedtime is false and refreshedcalling is true then it will reload the page
        window.location.reload(); // reloading the page
      }
    });
  }

  opendialog(){
    this.ref = this.dialog.open(this.DialogComponent);
  }

  checkorientation(){
    this.ispotrait = window.innerHeight > window.innerWidth ? true : false;
  }

  langclick(){
    this.showlang = !this.showlang
  }

  opneprivacy(type){
    if(this.ref){
      this.ref.close();
    }
    this.datatype = type
    this.ref = this.dialog.open(this.privacycomponent);
  }

  changelang(lang){
    sessionStorage.setItem('lang', lang.code);
    this.apiservice.language.next(lang)
    this.langvalue = lang.code;
    this.showlang = false;
  }
  openwebsite(link){
    // console.log(link);
    window.open(
      link,
      "_blank",
    );
  }

  setimage() {
    return "../assets/images/airlineLogos/" + this.langvalue + "flag.svg";
  }
  closedialog(){
    this.ref.close();
  }
  
  ngOnDestroy(){
    clearInterval(this.timer);
    if (this.connectivitySubscription) {
      this.connectivitySubscription.unsubscribe();
    }
  }

}
